import { Component, inject, computed } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatchedLeadsProductPublicDto } from '@/app/models/public/matchedLeadsProduct.public.dto';
import { DriverApplicationFormComponent } from '../driver-application-form/driver-application-form.component';
import { JobPositionPublicDto } from '@/app/models/public';

export interface DriverApplicationModalData {
  matchedLeadsProduct?: MatchedLeadsProductPublicDto;
  jobPosition?: JobPositionPublicDto;
}

@Component({
  selector: 'app-driver-application-modal',
  templateUrl: './driver-application-modal.component.html',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    DriverApplicationFormComponent,
  ],
})
export class DriverApplicationModalComponent {

  private dialogRef = inject(MatDialogRef<DriverApplicationModalComponent>);
  readonly data: DriverApplicationModalData = inject(MAT_DIALOG_DATA) ?? {};

  get matchedLeadsProduct(): MatchedLeadsProductPublicDto | undefined {
    return this.data.matchedLeadsProduct;
  }

  get jobPosition(): JobPositionPublicDto | undefined {
    return this.data.jobPosition;
  }

  get title(): string {
    const mlp = this.matchedLeadsProduct;
    const job = this.jobPosition;

    if (job && mlp) {
      return `Apply for this position with ${mlp.name}`;
    }
    if (mlp) {
      return `Apply to work for ${mlp.name}`;
    }
    return 'Get matched today';
  }

  get jobPositionId(): string | undefined {
    return this.jobPosition?.id ?? undefined;
  }

  close(): void {
    this.dialogRef.close();
  }
}
